import { render, staticRenderFns } from "./orgManage.vue?vue&type=template&id=f1f295ba&scoped=true&"
import script from "./orgManage.vue?vue&type=script&lang=js&"
export * from "./orgManage.vue?vue&type=script&lang=js&"
import style0 from "./orgManage.vue?vue&type=style&index=0&id=f1f295ba&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1f295ba",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\workspace\\uat\\platform-uat\\Platform-foundation-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f1f295ba')) {
      api.createRecord('f1f295ba', component.options)
    } else {
      api.reload('f1f295ba', component.options)
    }
    module.hot.accept("./orgManage.vue?vue&type=template&id=f1f295ba&scoped=true&", function () {
      api.rerender('f1f295ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/orgManage.vue"
export default component.exports